import type { PapelUsuario } from '@pgcustom/shared-types';

export interface PermissoesBonusPg {
  ler: boolean;
  criar: boolean;
  atualizar: boolean;
}

/**
 * Espelho, no frontend, do grant real de RBAC do recurso `societario`
 * (`apps/api/src/modules/societario/societario.routes.ts`, seed original
 * da migration `021`): só `admin` (curinga `*`) e `financeiro` têm
 * `ler`/`criar`/`atualizar` sobre este recurso — mesmo grant que já
 * cobre aportes/participação/retiradas, agora reaproveitado pela
 * administração do Bônus PG (nenhum novo grant precisou ser criado).
 * Usado apenas para decidir o que mostrar na UI — a autorização real é
 * sempre revalidada pelo backend.
 */
export function permissoesBonusPg(papel: PapelUsuario): PermissoesBonusPg {
  if (papel === 'admin' || papel === 'financeiro') {
    return { ler: true, criar: true, atualizar: true };
  }
  return { ler: false, criar: false, atualizar: false };
}
